import { useParams } from 'react-router-dom';

import AccessoryComponent from 'components/desktop/Accessory/AccessoryComponent';
import { Optional } from 'functions/promiseExtensions';
import useCurrency from 'hooks/redux/useCurrency';
import { useReaction } from 'hooks/useReaction';
import * as Accessory from 'types/Accessory/Detail/Accessory';

const AccessoryNewContainer = () => {
	const { id } = useParams();
	const currency = useCurrency();

	const [accessory, isLoaded] = useReaction(
		Optional.None<Accessory.Type>(),
		Accessory.getFromApiOrCreate,
		id,
		currency
	);

	return (
		<main className="container">
			{accessory.hasValue() && (
				<AccessoryComponent initialState={accessory.get()} isLoading={!isLoaded} />
			)}
		</main>
	);
};

export default AccessoryNewContainer;
